(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orvune-customer-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orvune-review-slider')) {
  customElements.define('orvune-review-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-review-slide]')];
      this.track = this.querySelector('[data-review-track]');
      this.dots = [...this.querySelectorAll('[data-review-dot]')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.slides.length) return;
      this.setAttribute('data-ready', '');
      this.show(0);
      if (this.slides.length < 2) return;
      this.querySelector('[data-review-controls]').hidden = false;
      this.querySelector('[data-review-next]').addEventListener('click', () => { this.show(this.index + 1); this.start(); }, options);
      this.querySelector('[data-review-prev]').addEventListener('click', () => { this.show(this.index - 1); this.start(); }, options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => { this.show(index); this.start(); }, options));
      this.querySelector('[data-review-pause]').addEventListener('click', () => { this.paused = !this.paused; this.start(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.start(); }, options);
      document.addEventListener('visibilitychange', () => this.start(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.reviewBlock === event.detail.blockId);
        if (index >= 0) { this.paused = true; this.show(index); this.start(); }
      }, options);
      this.start();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';
      this.slides.forEach((slide, i) => { slide.inert = i !== this.index; slide.setAttribute('aria-hidden', String(i !== this.index)); });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      const counter = this.querySelector('[data-review-counter]');
      if (counter) counter.textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
    stop() { clearInterval(this.timer); }
    start() {
      this.stop();
      const button = this.querySelector('[data-review-pause]');
      if (button) { button.textContent = this.paused ? '▶' : 'Ⅱ'; button.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel); }
      if (this.paused || this.hovered || document.hidden || this.contains(document.activeElement)) return;
      this.timer = setInterval(() => this.show(this.index + 1), 6000);
    }
    disconnectedCallback() { this.stop(); this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
